module.exports = __webpack_public_path__ + "static/media/om_hairstyle_loose_back_vector.7b966384.svg";